export default "__VITE_ASSET__09151b8d__"